import React from "react";

// Shared sparkline — static SVG polyline with an optional actuals/forecast
// divider. Extracted verbatim from DAModulePage.js:245 for reuse by the cat-1
// Forecast Wizard. W-047.4 (2026-10-02): the ONE sparkline -- DAModulePage, PayrollPage and
// RevenueBuildPage import it; their private copies are deleted (a copy took actualsLen; divIdx = actualsLen - 1).
export default function Spark({ data, color = "#3D85C6", w = 200, h = 32, divIdx }) {
  if (!data?.length) return null;
  const mx = Math.max(...data, 1), mn = Math.min(...data, 0), rng = mx - mn || 1;
  // divIdx is the actuals/forecast split: index of the last actuals point.
  const showDivider = typeof divIdx === 'number' && divIdx >= 0 && divIdx < data.length - 1;
  const divX = showDivider ? ((divIdx + 1) / (data.length - 1)) * w : 0;
  const pts = data.map((v, i) => `${(i / (data.length - 1)) * w},${h - ((v - mn) / rng) * (h - 4) - 2}`).join(" ");
  return <svg width={w} height={h} style={{ display: "block" }}>
    {showDivider && <rect x={0} y={0} width={divX} height={h} fill="rgba(0,0,0,0.04)" rx="2" />}
    {showDivider && <line x1={divX} y1={0} x2={divX} y2={h} stroke="rgba(61,133,198,0.4)" strokeWidth="1" strokeDasharray="2,2" />}
    <polyline fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" points={pts} />
  </svg>;
}
